import { loginClearError, storeUserMetadata } from '../store/login/login.actions';
import { loginComplete } from '../store/login/login.actions';
import { Login } from '../components/login';
import { retailerApi } from '@common/retailer-api';
import { getPortalBaseUrlForCurrentHost } from '../utils/iam-login-url';
import { logIamFailure } from '@common/iam-login-log';
const {
  useEffect
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const logger = svs.core.log.getLogger('welcome:LoginContainer');
export const LoginContainer = () => {
  const dispatch = useDispatch();
  const [getRetailerInfo, {
    data: retailerInfo,
    error: retailerInfoError
  }] = retailerApi.useLazyGetUserProfileQuery();
  const {
    hasStoredUserMetadata,
    isAuthenticated,
    isComplete,
    isMissingUserMetadata,
    retailerId,
    error
  } = useSelector(({
    login
  }) => login);
  const hasToChangePassword = useSelector(({
    login
  }) => login.isComplete && login.mustChangePassword);
  const isIamFlow = new URLSearchParams(window.location.search).get('iam') === '1';
  useEffect(() => {
    if (isAuthenticated && !isComplete) {
      getRetailerInfo();
    }
  }, [isAuthenticated, isComplete, getRetailerInfo]);
  useEffect(() => {
    if (retailerInfo) {
      dispatch(storeUserMetadata(retailerInfo));
    }
  }, [dispatch, retailerInfo, retailerInfoError]);
  useEffect(() => {
    if (retailerInfoError) {
      logIamFailure(logger, {
        method: window.location.pathname?.includes('/bank-id') ? 'bankid' : 'username',
        retailerId,
        stage: 'metadata',
        reason: 'profile_fetch_failed',
        code: retailerInfoError.data?.error?.code,
        httpStatus: retailerInfoError.status
      });
    }
  }, [retailerInfoError, retailerId]);
  useEffect(() => {
    if (hasStoredUserMetadata) {
      dispatch(loginComplete());
    }
  }, [dispatch, hasStoredUserMetadata, isIamFlow]);
  const handleCloseMetadataErrorDialog = () => dispatch(loginComplete());
  const handleCloseErrorDialog = () => {
    dispatch(loginClearError());
    window.location.assign(getPortalBaseUrlForCurrentHost());
  };
  return <Login error={error} hasMissingUserMetadata={Boolean(retailerInfoError) || isMissingUserMetadata} hasToChangePassword={hasToChangePassword} isAuthenticated={isAuthenticated} isComplete={isComplete} onCloseErrorDialog={handleCloseErrorDialog} onCloseMetadataErrorDialog={handleCloseMetadataErrorDialog} />;
};